import { Button } from "../ui/button";
import { Input } from "../ui/input";
import DateInput from "../DateInput";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { PosSplitFields } from "./PosSplitFields";

export const EntrataDialog = ({ open, onOpenChange, form, onFormChange, metodiEntrata, banchePos, onSubmit }) => {
  const isDetailedPos = (form.metodo || "").toLowerCase() === "pos" && banchePos.length > 0;
  return (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-card border-border">
      <DialogHeader>
        <DialogTitle className="text-foreground">Nuova Entrata</DialogTitle>
        <DialogDescription className="sr-only">Registra una nuova entrata e il relativo metodo di incasso.</DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label className="text-foreground/70">Data</Label>
          <DateInput value={form.data || ""} onChange={(v) => onFormChange({ ...form, data: v })} />
        </div>
        <div className="space-y-2">
          <Label className="text-foreground/70">Metodo *</Label>
          <Select value={form.metodo || ""} onValueChange={(v) => onFormChange({ ...form, metodo: v })}>
            <SelectTrigger className="bg-card border-border text-foreground" data-testid="entry-method-select"><SelectValue placeholder="Seleziona" /></SelectTrigger>
            <SelectContent>
              {metodiEntrata.map((m) => (<SelectItem key={m} value={m}>{m}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
        {isDetailedPos ? (
          <PosSplitFields
            banks={banchePos}
            values={form.split_pos || {}}
            onChange={(split_pos) => onFormChange({ ...form, split_pos })}
            prefix="single-entry"
          />
        ) : (
          <div className="space-y-2">
            <Label className="text-foreground/70">Importo (€) *</Label>
            <Input type="number" step="0.01" value={form.importo || ""} onChange={(e) => onFormChange({ ...form, importo: e.target.value })} placeholder="0.00" required className="bg-card border-border text-foreground" data-testid="entry-amount-input" />
          </div>
        )}
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="border-border text-foreground hover:bg-accent hover:text-accent-foreground" data-testid="entry-cancel-button">Annulla</Button>
          <Button type="submit" className="bg-lime-500 hover:bg-lime-400 text-black" data-testid="entry-save-button">Salva</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
  );
};
